const contentSubscribe = () => import('@/pages/content/subscribe/index.vue');

export default [{
    path: '/content/subscribe',
    component: contentSubscribe,
    meta: [{
        name: '内容管理',
		activeRoute: '/content/manage'
    },
    {
        name: '订阅我们',
        activeRoute: '/content/subscribe'
    }]
}];